<template>
  <div>
    <div class="container">
        <p id="dashboardItemTitle">Create New Template</p>
      <div class="card">
        <div class="card-content">
          <div class="content">
            <section>

              <b-field horizontal
                       :type="invalidName  == '' ? '' : 'is-danger'"
                       :message="invalidName">
                <template slot="label">Template Name<span class="has-text-danger">*</span></template>
                <b-input @input="resetInvalidStatus('invalidName')" v-model="formData.name"></b-input>
              </b-field>

              <b-field horizontal
                       :type="invalidDepartment  == '' ? '' : 'is-danger'"
                       :message="invalidDepartment">
                <template slot="label">Department<span class="has-text-danger">*</span></template>
                <b-select placeholder="Select a Department" expanded @input="resetInvalidStatus('invalidDepartment')"
                          v-model="formData.department">
                  <option
                      v-for="option in departmentList "
                      :value="option.name"
                      :key="option.id">
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>


              <b-field horizontal
                       :type="invalidTemplateCategory  == '' ? '' : 'is-danger'"
                       :message="invalidTemplateCategory">
                <template slot="label">Template Category<span class="has-text-danger">*</span></template>
                <b-select placeholder="Select a Template Category"
                          v-model="formData.template_category" expanded
                          @input="resetInvalidStatus('invalidTemplateCategory')">
                  <option
                      v-for="option in templateCategoryList"
                      :value="option.name"
                      :key="option.id">
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>

              <b-field horizontal>
                <div class="block"></div>
              </b-field>

              <div class="tile custom-tile-narrow">
                <div class="column">
                  <div class="columns">
                    <div class="column">
                      <p class="has-text-danger is-italic">Fields marked with <big>*</big> are mandatory</p>
                    </div>
                    <div class="buttons">
                      <b-button  :loading="formIsSubmitting" type="is-success" @click="validateAndSubmit()">Save</b-button>
                      <b-button @click="$navigate(-1)"  type="is-danger">Cancel</b-button>
                    </div>
                  </div>
                </div>
              </div>

            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from "axios";

import axios from "axios";

export default {

  name:'template-create',

  data(){
    return {
      departmentList:[],
      templateCategoryList:[],
      formIsSubmitting:false,

      invalidName:'',
      invalidDepartment:'',
      invalidTemplateCategory:'',

      formData:{
        name:'',
        department:null,
        template_category:null
      },

      regex:{
        name: /^[a-zA-Z][a-zA-Z ]+$/,
      },

      formIsInvalid:false,
      templateID:''
    }
  },

  methods:{


    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false
    },

    //department & category
    getDataList:function (){
        const comp = this
        try {

          axios.post(comp.$base_url+'/agent/getDataListforDropdown', {
            auth_token:comp.$root.agentAuthToken,
            user_id:comp.$root.user_id
          })
              .then(function (response) {
                console.log(response)
                comp.departmentList = response.data.departmentList
                comp.templateCategoryList = response.data.categoryList
              })
              .catch(function (error) {
                console.log(error)

                comp.$buefy.toast.open({
                  message: "Failed to get departments",
                  type: "is-danger",
                });
              });

        }
        catch (e) {
          comp.$buefy.toast.open({
            message: "Failed to get departments",
            type: "is-danger",
          });
          console.log("Exception occurred in getDepartmentList() : "+e.message)
        }
      },


    validateForm:function (){
      var formIsValid = true

      // Role Name
      if(this.formData.name.trim().length === 0){
        this.invalidName = 'This field cannot left blank'
        formIsValid = false
      }
      else if(this.formData.name =='' ){
        this.invalidName = 'This field cannot left blank'
        formIsValid = false

      }else if(!this.regex.name.test(this.formData.name)){
        this.invalidName = 'Template Name cannot contain special characters or numbers'
        formIsValid = false

      }else if(this.formData.name.length > 20){
        this.invalidName  = 'Template Name must be no longer than 20 characters'
      }

      //department
      if(this.formData.department == null){
        this.invalidDepartment = 'This field cannot left blank'
        formIsValid = false
      }

      //template category
      if(this.formData.template_category == null){
        this.invalidTemplateCategory = 'This field cannot left blank'
        formIsValid = false
      }


      if(formIsValid){
        return true
      }
      else{
        return false
      }
    },

    //check authentication
    validateToken:function (){
      var component = this

      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken
      })
          .then(function (data) {
            var array =[]
            array = data.data


            console.log(array.data.message)
            if(array.success == true){
              console.log(array.data.message)
              //load department & template ctg
              component.getDataList()

            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.data.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });

    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
      else{
        this.formIsInvalid = true
      }
    },

    submitForm:function (){
      var component = this
      component.formIsSubmitting = true
      axios.post(component.$base_url+'/agent/updateFirstStep', {
        auth_token:component.$root.agentAuthToken,
        user_id:component.$root.user_id,
        department:component.formData.department,
        template_category:component.formData.template_category,
        name:component.formData.name
      })
          .then(function (data) {
            component.formIsSubmitting = false
            var array =[]
            array = data.data

            console.log(array.data.message)
            if(array.success == true){
              console.log(array.data)
              component.templateID =  array.data.templateID
              component.$router.push({name:'documentCreate',params:{id:component.templateID}})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });
    }


  },

  mounted() {
    this.validateToken()

  },

}

</script>
<style >
#dashboardItemTitle{
  color: #A5A6B3;
  font-weight: 600;
  font-size: 30px;
  text-align: left
}

.help{
  float: left;
}
</style>
